import React, { useState } from 'react'
import { Collapse, makeStyles } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import { DownArrowIcon } from 'transfix-icons'
import { brandColors } from 'transfix-ui'

interface ICollapsibleSection {
  children: React.ReactNode
  Title: React.FC
  padding?: string | number
  defaultOpen?: boolean
}

const useStyles = makeStyles({
  flipped: {
    transform: 'rotate(180deg)',
  },
})

export const CollapsibleSection = ({
  Title,
  children,
  defaultOpen = false,
  padding = '16px',
}: ICollapsibleSection) => {
  const classes = useStyles()
  const [isCollapsed, setIsCollapsed] = useState<boolean>(!defaultOpen)

  const color = children ? 'black' : 'coolGray3'
  const iconClasses = isCollapsed ? classes.flipped : ''

  const ToggleIcon = () => <DownArrowIcon className={iconClasses} color={color} />
  const toggleIsCollapsedHandler = () =>
    !!children && setIsCollapsed(previousState => !previousState)

  return (
    <div>
      <Box
        onClick={toggleIsCollapsedHandler}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        width='100%'
        borderBottom={`1px solid ${brandColors.coolGray3}`}
        pb='4px'>
        <Title />
        <ToggleIcon />
      </Box>
      <Collapse in={!isCollapsed}>
        <Box py={padding}>{children}</Box>
      </Collapse>
    </div>
  )
}
